import React from 'react';

const ProductsSection = () => {
  return (
    <section id="products" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-24">
          <p className="text-emerald-700 text-sm font-medium tracking-widest uppercase mb-6">Our Products</p>
          <h2 className="text-5xl md:text-6xl font-light text-gray-900 mb-6 tracking-tight">
            Agricultural Commodities
          </h2>
        </div>

        <div className="bg-white shadow-2xl overflow-hidden">
          <div className="grid md:grid-cols-5 gap-0">
            <div className="relative md:col-span-2 h-96 md:h-auto">
              <img
                src="https://images.unsplash.com/photo-1642497393440-4b5cc5f03ff5"
                alt="Premium quality brown flaxseed (linseed)"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="md:col-span-3 p-16 flex flex-col justify-center">
              <h3 className="text-4xl font-light text-gray-900 mb-10 tracking-tight">
                Oilseeds
              </h3>

              <div className="space-y-7 text-gray-600">
                <p className="text-xl leading-relaxed font-light">
                  Kazakhstan is one of the world's major producers of agricultural commodities, with a strong focus on oilseed production.
                </p>

                <p className="text-xl leading-relaxed font-light">
                  Irgiz Export LLP sources high-quality oilseeds directly from agricultural producers in Northern Kazakhstan and organizes export deliveries to international markets.
                </p>

                <p className="text-xl leading-relaxed font-light">
                  We offer flexible product preparation and can adjust specifications according to buyer requirements.
                </p>
              </div>

              <div className="mt-12 pt-8 border-t border-gray-200">
                <p className="text-emerald-800 font-medium text-lg">
                  Direct sourcing • Quality control • Flexible specifications
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
